import { i18n } from "services/i18nService";

export const FIELDS_TO_TRANSFORM = {
  DECIMAL_FIELDS: [],
  MONEY_FIELDS: [
    "subscription",
    "billableUsersCharge",
    "billableIntegrationsCharge",
    "billableSmsUsersCharge",
    "discount",
    "salesTax",
  ],
  DATE_FIELDS: [],
  DATETIME_FIELDS: [],
  NON_UTC_DATETIME_FIELDS: [],
};

export const OTHER_CANCELLATION_REASON_OPTION = {
  id: 14,
  name: i18n("accountInformation.Other"),
  reasonString: "Other",
};

export const CANCELLATION_REASON_OPTIONS = [
  {
    id: 1,
    name: i18n("accountInformation.BusinessClosed"),
    reasonString: "Business closed",
  },
  {
    id: 2,
    name: i18n("accountInformation.CompanySoldOrMerged"),
    reasonString: "Company sold or merged",
  },

  {
    id: 3,
    name: i18n("accountInformation.SwitchedSoftwareProvider"),
    reasonString: "Switched software provider",
  },
  {
    id: 4,
    name: i18n("accountInformation.NoLongerUsingQuickBooksOnline"),
    reasonString: "No longer using QuickBooks Online",
  },
  {
    id: 5,
    name: i18n("accountInformation.NeedMoreTime"),
    reasonString: "Need more time",
  },
  {
    id: 6,
    name: i18n("accountInformation.NotAGoodFit"),
    reasonString: "Not a good fit",
  },
  {
    id: 7,
    name: i18n("accountInformation.PricingConcerns"),
    reasonString: "Pricing concerns",
  },
  {
    id: 8,
    name: i18n("accountInformation.SoftwareBugs"),
    reasonString: "Software bugs",
  },
  {
    id: 9,
    name: i18n("accountInformation.SlowPerformance"),
    reasonString: "Slow performance",
  },
  {
    id: 10,
    name: i18n("accountInformation.PoorCustomerService"),
    reasonString: "Poor customer service",
  },
  {
    id: 11,
    name: i18n("accountInformation.DidntUnderstandHowToUseSoftware"),
    reasonString: "Didn't understand how to use software",
  },
  {
    id: 12,
    name: i18n("accountInformation.ThirdPartyIntegrationChallenges"),
    reasonString: "Third party integration challenges",
  },
  {
    id: 13,
    name: i18n("accountInformation.CreatingNewSOSInventoryAccount"),
    reasonString: "Creating new SOS Inventory account",
  },
  OTHER_CANCELLATION_REASON_OPTION,
];
